import { AreaSelectDialogProps } from '../../types/inventory'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React, { useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { Ripple } from 'primereact/ripple'
import PrimeReact from 'primereact/api'
import AreaOrSectorSaveDialog from './AreaOrSectorSaveDialog'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const AreaSelectDialog = (props: AreaSelectDialogProps) => {
    const { t } = useTranslation()
    PrimeReact.ripple = true

    useMountEffect(() => {
        // findArea()
    })

    const [addItemVisible, setAddItemVisible] = useState<boolean>(false)

    const onClickArea = (areaId: string) => {
        props.onHide && props.onHide(areaId)
    }

    const onClickAddArea = () => {
        setAddItemVisible(true)
    }

    const footer = () => {
        return (
            <div className="grid">
                <div className="col-6">
                    <Button
                        className="w-full p-button-secondary mt-4"
                        label={t(tokens.common.close)}
                        size="large"
                        onClick={() => props.onHide && props.onHide(undefined)}
                    />
                </div>
                <div className="col-6">
                    <Button
                        className="w-full p-button-info mt-4 col-6"
                        icon="pi pi-plus"
                        iconPos="left"
                        label={t(tokens.common.add)}
                        size="large"
                        onClick={onClickAddArea}
                    />
                </div>
            </div>
        )
    }

    const onHideAddDialog = (isChange: boolean, type?: 'AREA' | 'SECTOR') => {
        if (isChange) {
            props.onAddLocation(type || 'AREA')
        }
        setAddItemVisible(false)
    }

    return (
        <>
            <Dialog
                header={t(tokens.common.select_zone)}
                visible={props.visible}
                onHide={() => props.onHide(undefined)}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
                style={{ width: '60vh' }}
            >
                <div style={{ minHeight: '300px', maxHeight: '350px' }}>
                    {props.areas &&
                        props.areas.map((area) => (
                            <div key={area.areaId}>
                                <div className="font-bold text-2xl border-bottom-1 py-4 p-ripple" onClick={() => onClickArea(area.areaId)}>
                                    {area.areaNm}
                                    <Ripple />
                                </div>
                            </div>
                        ))}
                </div>
                {addItemVisible && <AreaOrSectorSaveDialog visible={addItemVisible} onHide={onHideAddDialog} />}
            </Dialog>
        </>
    )
}

export default AreaSelectDialog
